import ImagesWishlistWishlistPng from '@/public/images/wishlist/wishlist.png';

export { ImagesWishlistWishlistPng };
